module.exports = __webpack_public_path__ + "static/img/tecnm.f36b3f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tecnm.png
// module id = 562
// module chunks = 1